const DOLLARS_TO_CENTS = 100;

export const formatPriceAsCents = (price: string | number) =>
  Math.ceil(Number(price) * DOLLARS_TO_CENTS);
